<template>

  <nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <a class="navbar-item" href="http://lmc-soluzioni.it">
        <img src="../assets/LogoLMC.webp">
      </a>
      <a role="button" class="navbar-burger" aria-label="menu" aria-expanded="false" data-target="navbarGenerale" @click="mostraMenuBurger" v-if="credenzialiUtente">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div id="navbarGenerale" class="navbar-menu" :class="menuBurgerVisibile ? 'is-active' : ''" v-if="credenzialiUtente">
      <div class="navbar-start">
        <a class="navbar-item" @click="voceMenuSelezionata('Home')">
          Home
        </a>
        <a class="navbar-item" @click="voceMenuSelezionata('ElencoClienti')">
          Clienti
        </a>
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            Lead
          </a>
          <div class="navbar-dropdown">
            <a class="navbar-item" @click="voceMenuSelezionata('ElencoLeads')">
              Elenco
            </a>
            <a class="navbar-item" @click="voceMenuSelezionata('ElencoPreventivi')">
              Preventivi
            </a>
          </div>
        </div>
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            Lavori
          </a>
          <div class="navbar-dropdown">
            <a class="navbar-item" @click="voceMenuSelezionata('ElencoLavori')">
              Elenco
            </a>
            <a class="navbar-item" @click="voceMenuSelezionata('ElencoFasi')">
              Fasi
            </a>
            <a class="navbar-item" @click="voceMenuSelezionata('ElencoCosti')" v-if="impostazioniGenerali.mostraTest">
              Costi
            </a>
            <a class="navbar-item" @click="voceMenuSelezionata('ElencoDico')">
              Dico
            </a>
          </div>
        </div>
        <div class="navbar-item has-dropdown is-hoverable" v-if="mostraInfoSviluppo">
          <a class="navbar-link">
            Amministrazione
          </a>
          <div class="navbar-dropdown">
            <a class="navbar-item" @click="voceMenuSelezionata('ElencoLavori')">
              Contabilità
            </a>
          </div>
        </div>
        <a class="navbar-item" @click="voceMenuSelezionata('ElencoContatti')">
          Contatti
        </a>
        <a class="navbar-item" @click="voceMenuSelezionata('ElencoListini')">
          Listini
        </a>
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            Altro
          </a>
          <div class="navbar-dropdown">
            <a class="navbar-item" @click="voceMenuSelezionata('PaginaTemplate')">
              Template
            </a>
            <a class="navbar-item" @click="voceMenuSelezionata('PaginaSviluppo')">
              Utilità
            </a>
            <a class="navbar-item" @click="voceMenuSelezionata('About')">
              About
            </a>
            <a class="navbar-item" @click="LogoutClick">
              Logout
            </a>
          </div>
        </div>
      </div>

    </div>
  </nav>

</template>

<script setup>
  import { defineEmits, ref } from "vue";
  import { logoutUtente, credenzialiUtente } from '../code/firebase';
  import { mostraInfoSviluppo, impostazioniGenerali } from "../code/utilita";

    // PROPRIETA' ED EVENTI DEL COMPONENTE
  const emit = defineEmits(['voceMenuSelezionata']);

    // VARIABILI DEL COMPONENTE
  const menuBurgerVisibile = ref(false);

    // FUNZIONI DEL COMPONENTE
  function mostraMenuBurger() {
    // Quando seleziono il burger faccio comparire (o sparire) il menu
    !menuBurgerVisibile.value ? menuBurgerVisibile.value = true : menuBurgerVisibile.value = false;
  }

  function LogoutClick() {
    // Effettuo logout
    logoutUtente();
  }

  function voceMenuSelezionata(voce) {
    menuBurgerVisibile.value = false;
    emit('voceMenuSelezionata', voce);
  }
</script>